/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-logout[_ngcontent-%COMP%]{position:absolute;background:#fff;top:65px;bottom:0;left:0;right:0}"];
export { styles as styles };
